import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

interface CenteredSpinnerProps {
  className?: string;
  containerClassName?: string;
  size?: "sm" | "default" | "lg" | "xl";
  minHeight?: string;
}

export function CenteredSpinner({
  className,
  containerClassName,
  size = "lg",
  minHeight = "min-h-[300px]",
}: CenteredSpinnerProps) {
  return (
    <div className={cn("flex justify-center items-center", minHeight, containerClassName)}>
      <Spinner size={size} className={cn("text-primary", className)} />
    </div>
  );
}
